// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/outview3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section4_container__V0\\+O3 {
  /*background-image: url(/public/images/outview3.png); */
  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center; /* 세로 중앙 정렬 */
  padding: 5%;
}

.section4_text-small__7Ah8p {
  letter-spacing: 5px;
  font-size: 16px;
  color: white;
  margin-bottom: 5px;
}

.section4_text-mid__-01xW {
  font-size: 21px;
  color: white;
  margin-bottom: 40px;
  
}

.section4_text-large__5kagZ {
  margin-top: 0;
  font-size: 45px;
  color: white;
  font-weight: 500;
  margin-bottom: 30px;
}


.section4_text-large2__OB-iG {
  font-size: 30px;
  color: white;
  font-weight: 500;
}

.section4_rounded-box__kTXum {
  display: flex; /* 플렉스 박스 적용 */
  justify-content: center; /* 가로 중앙 정렬 */
  align-items: center; /* 세로 중앙 정렬 */

  width: 500px;  /* 원하는 크기로 조절 */
  height: 80px; /* 원하는 높이로 조절 */
  background: rgba(0, 114, 187, 0.8);
  border: 2px solid rgba(255, 255, 255, 0.4); /* 테두리를 약간만 보이게 */
  border-radius: 50px; /* 상하 50px 반원 */
}

.section4_modal__OZcUM {
  position: fixed;
  
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3); /* 반투명 배경 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.section4_modal-content__5rOOX {
  background: white;
  padding: 10px;
  border-radius: 10px;
  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */
}

.section4_modal-content__5rOOX img {
  border-radius: 10px;
  width: 100%;
  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */
}

/* 투명한 div (오버레이) */
.section4_overlay__zhehG {
  position: absolute;
  top : 0;
  left : 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5); /* 반투명 배경 */
  z-index: 200; /* 이미지 뒤에 깔릴 수 있도록 설정 */
}


@media (max-width: 767px) {

  .section4_container__V0\\+O3 {
    padding-top: 30px;
    padding-bottom: 35px;
  }

  .section4_image-plus__AS23S {
    width : 30px;
  }

  .section4_rounded-box__kTXum {
    width: 300px;  /* 원하는 크기로 조절 */
    height: 60px; /* 원하는 높이로 조절 */
  }

  .section4_text-small__7Ah8p {
    font-size: 10px;
  }

  .section4_text-mid__-01xW {
    font-size: 14px;
  }

  .section4_text-large__5kagZ {
    font-size: 36px;
  }

  .section4_text-large2__OB-iG {
    font-size: 18px;
  }
}

@media (min-width: 768px) {
  .section4_text-large__5kagZ {
    font-size: 80px;
  }

  .section4_text-mid__-01xW {
    margin-bottom: 80px;
  }
  
}`, "",{"version":3,"sources":["webpack://./src/Sections/section4.module.css"],"names":[],"mappings":"AAAA;EACE,uDAAuD;EACvD,4GAAuG;EACvG,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB,EAAE,aAAa;EAClC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa,EAAE,cAAc;EAC7B,uBAAuB,EAAE,aAAa;EACtC,mBAAmB,EAAE,aAAa;;EAElC,YAAY,GAAG,eAAe;EAC9B,YAAY,EAAE,eAAe;EAC7B,kCAAkC;EAClC,0CAA0C,EAAE,iBAAiB;EAC7D,mBAAmB,EAAE,eAAe;AACtC;;AAEA;EACE,eAAe;;EAEf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,WAAW;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa,EAAE,uBAAuB;AACxC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa,EAAE,uBAAuB;AACxC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,8BAA8B,EAAE,WAAW;EAC3C,YAAY,EAAE,uBAAuB;AACvC;;;AAGA;;EAEE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY,GAAG,eAAe;IAC9B,YAAY,EAAE,eAAe;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;AAEF","sourcesContent":[".container {\n  /*background-image: url(/public/images/outview3.png); */\n  background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url('/public/images/outview3.png');\n  background-size: cover;\n  background-position: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center; /* 세로 중앙 정렬 */\n  padding: 5%;\n}\n\n.text-small {\n  letter-spacing: 5px;\n  font-size: 16px;\n  color: white;\n  margin-bottom: 5px;\n}\n\n.text-mid {\n  font-size: 21px;\n  color: white;\n  margin-bottom: 40px;\n  \n}\n\n.text-large {\n  margin-top: 0;\n  font-size: 45px;\n  color: white;\n  font-weight: 500;\n  margin-bottom: 30px;\n}\n\n\n.text-large2 {\n  font-size: 30px;\n  color: white;\n  font-weight: 500;\n}\n\n.rounded-box {\n  display: flex; /* 플렉스 박스 적용 */\n  justify-content: center; /* 가로 중앙 정렬 */\n  align-items: center; /* 세로 중앙 정렬 */\n\n  width: 500px;  /* 원하는 크기로 조절 */\n  height: 80px; /* 원하는 높이로 조절 */\n  background: rgba(0, 114, 187, 0.8);\n  border: 2px solid rgba(255, 255, 255, 0.4); /* 테두리를 약간만 보이게 */\n  border-radius: 50px; /* 상하 50px 반원 */\n}\n\n.modal {\n  position: fixed;\n  \n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3); /* 반투명 배경 */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 10px;\n  border-radius: 10px;\n  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */\n}\n\n.modal-content img {\n  border-radius: 10px;\n  width: 100%;\n  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */\n}\n\n/* 투명한 div (오버레이) */\n.overlay {\n  position: absolute;\n  top : 0;\n  left : 0;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.5); /* 반투명 배경 */\n  z-index: 200; /* 이미지 뒤에 깔릴 수 있도록 설정 */\n}\n\n\n@media (max-width: 767px) {\n\n  .container {\n    padding-top: 30px;\n    padding-bottom: 35px;\n  }\n\n  .image-plus {\n    width : 30px;\n  }\n\n  .rounded-box {\n    width: 300px;  /* 원하는 크기로 조절 */\n    height: 60px; /* 원하는 높이로 조절 */\n  }\n\n  .text-small {\n    font-size: 10px;\n  }\n\n  .text-mid {\n    font-size: 14px;\n  }\n\n  .text-large {\n    font-size: 36px;\n  }\n\n  .text-large2 {\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 768px) {\n  .text-large {\n    font-size: 80px;\n  }\n\n  .text-mid {\n    margin-bottom: 80px;\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section4_container__V0+O3`,
	"text-small": `section4_text-small__7Ah8p`,
	"text-mid": `section4_text-mid__-01xW`,
	"text-large": `section4_text-large__5kagZ`,
	"text-large2": `section4_text-large2__OB-iG`,
	"rounded-box": `section4_rounded-box__kTXum`,
	"modal": `section4_modal__OZcUM`,
	"modal-content": `section4_modal-content__5rOOX`,
	"overlay": `section4_overlay__zhehG`,
	"image-plus": `section4_image-plus__AS23S`
};
export default ___CSS_LOADER_EXPORT___;
